<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </a-config-provider>
    <a-config-provider :locale="locale">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default {
  name: "app",
  data() {
    return {
      locale: zh_CN,
    };
  },
  };
</script>

<style>
</style>
